import rest from "../utils/rest";
import get from "lodash/get";
import { localRemoveItem, sessionRemoveItem } from "../utils/storage";
// @ts-ignore: Unreachable code error
import JSOG from "jsog";

const configAxios = (onError: () => void) => {
  rest.interceptors.response.use(
    response => {
      let data = response.data;
      if (response.config.responseType === "json") {
        if (get(data, "content", []).length) {
          data = {
            ...data,
            content: JSOG.decode(data.content)
          };
        } else {
          data = JSOG.decode(data);
        }
      }
      return { ...response, data };
    },
    error => {
      if (error.response) {
        if (get(error, "response.data.error", "") === "invalid_token") {
          localRemoveItem();
          sessionRemoveItem();
          onError();
        }
      } else if (error.request) {
      } else {
      }
      return Promise.reject(error);
    }
  );
};

export default configAxios;
